import './FilesPanel.scss';

export { default as FilesPanel } from './FilesPanel';
export { getFilesPanelSchema, getFilesPanelAdminSchema } from './filesPanelSchema';
